<div>
  <h1 mat-dialog-title *ngIf="data.title" [innerHTML]="data.title"></h1>

  <mat-dialog-content *ngIf="data.content" [innerHTML]="data.content"></mat-dialog-content>

  <mat-form-field *ngIf="data.showInputField" style="width: 100%;">
    <input matInput [(ngModel)]="data.InputField" [matAutocomplete]="auto" [matAutocompleteDisabled]="true" />
  </mat-form-field>

  <mat-form-field *ngIf="data.showTextarea" style="width: 100%;">
    <textarea
      matInput
      [(ngModel)]="data.textareavalue"
      placeholder="{{ data.placeholder }}"
      [matAutocomplete]="auto"
      [matAutocompleteDisabled]="true"
    ></textarea>
  </mat-form-field>
  <br />
  <span class="error">
    <span class="error" *ngIf="data.reqError">
      This field is required.
    </span>
  </span>

  <mat-dialog-actions class="pull-right">
    <div>
      <button
        *ngIf="data.yesButtonName"
        mat-raised-button
        [mat-dialog-close]="true"
        class="mat-primary ml10 pull-right mt10"
        [ngStyle]="{ 'background-color': !isDesktop ? '#6e2585' : '' }"
        tabindex="-1"
      >
        {{ data.yesButtonName }}
      </button>
      <button
        *ngIf="data.otherButtonName"
        mat-raised-button
        [mat-dialog-close]="'other'"
        class="mat-primary ml10 pull-right mt10"
        tabindex="-1"
        [ngStyle]="{ 'background-color': !isDesktop ? '#6e2585' : '' }"
      >
        {{ data.otherButtonName }}
      </button>

      <button
        *ngIf="data.noButtonName"
        mat-raised-button
        [mat-dialog-close]="false"
        class="mat-primary pull-right mt10"
        [ngStyle]="!isDesktop ? { 'background-color': '#FFFFFF', color: '#000000' } : {}"
        tabindex="-1"
      >
        {{ data.noButtonName }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
